import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { ContentModel, transformToUrlDescription } from '@uno/common-cms';
import { getPageInfo } from 'services/networking/navigation';
import { Entities } from '../types';
import { processChildNodes } from './convertHTMLToContentBlocks';
import { isElement } from './helpers';

var isLinkElement = function isLinkElement(node) {
  return isElement(node) && node.nodeName === 'A';
};
/**
 * Return true if the provided HTML Element can be used to build a link.
 */


export var isLink = function isLink(node) {
  if (!isLinkElement(node)) {
    return false;
  }

  if (!node.href || !['http:', 'https:', 'mailto:', 'tel:'].includes(node.protocol)) {
    return false;
  }

  try {
    // Check whether an URL can be created
    new URL(node.href);
    return true;
  } catch (_unused) {
    return false;
  }
};

var getInternalLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(urlDescription, node, processedNode) {
    var _pageInfo$pageLink$co, _node$getAttribute, _node$getAttribute2;

    var pageInfo, label, previewUrl, data, contentState, currentEntity;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getPageInfo(urlDescription);

          case 2:
            pageInfo = _context.sent;

            if (!(pageInfo === undefined)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", {
              contentState: processedNode.contentState,
              currentEntity: null
            });

          case 5:
            if (!(pageInfo._mainChunkModel !== ContentModel.Content || pageInfo.pageLink === undefined)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              contentState: processedNode.contentState,
              currentEntity: null
            });

          case 7:
            // NB : for performance reason (number of API calls, data transfer), the pageLink is used to compute label and previewUrl of the internal link
            // This is a shortcut, because the notion of internal link is a CONTENT notion, not a NAVIGATION one.
            // We handle this shortcut for performance reason and because label and previewUrl exist only for display purposes
            label = pageInfo.pageLink.title;
            previewUrl = (_pageInfo$pageLink$co = pageInfo.pageLink.coverImages["default"].imgUrl) !== null && _pageInfo$pageLink$co !== void 0 ? _pageInfo$pageLink$co : '';
            data = {
              contentId: pageInfo._mainChunkId,
              label: label,
              previewUrl: previewUrl,
              attributes: {
                rel: (_node$getAttribute = node.getAttribute('rel')) !== null && _node$getAttribute !== void 0 ? _node$getAttribute : undefined,
                target: (_node$getAttribute2 = node.getAttribute('target')) !== null && _node$getAttribute2 !== void 0 ? _node$getAttribute2 : undefined
              }
            };
            contentState = processedNode.contentState.createEntity(Entities.InternalLink, 'MUTABLE', data);
            currentEntity = processedNode.contentState.getLastCreatedEntityKey();
            return _context.abrupt("return", {
              contentState: contentState,
              currentEntity: currentEntity
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInternalLink(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getExternalLink = function getExternalLink(url, node, processedNode) {
  var _node$getAttribute3, _node$getAttribute4;

  // External link
  var data = {
    url: url,
    attributes: {
      rel: (_node$getAttribute3 = node.getAttribute('rel')) !== null && _node$getAttribute3 !== void 0 ? _node$getAttribute3 : 'nofollow',
      target: (_node$getAttribute4 = node.getAttribute('target')) !== null && _node$getAttribute4 !== void 0 ? _node$getAttribute4 : '_blank'
    }
  };
  var contentState = processedNode.contentState.createEntity(Entities.ExternalLink, 'MUTABLE', data);
  var currentEntity = processedNode.contentState.getLastCreatedEntityKey();
  return {
    contentState: contentState,
    currentEntity: currentEntity
  };
};
/**
 * Add the content of an HTML 'a' node to the internal state. Child nodes
 * (if any) are converted to Block Configs and appended to the provided
 * blockConfig array.
 */


export var addLinkEntity = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(siteId, node, processedNode) {
    var url, stage, urlDescription, _ref3, contentState, currentEntity;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = new URL(node.href);
            stage = process.env.STAGE; // remove no cache param

            url.searchParams["delete"]('no-cache');
            urlDescription = transformToUrlDescription({
              siteId: siteId,
              url: url.href,
              stage: stage
            });

            if (!urlDescription) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return getInternalLink(urlDescription, node, processedNode);

          case 7:
            _context2.t0 = _context2.sent;
            _context2.next = 11;
            break;

          case 10:
            _context2.t0 = getExternalLink(node.href, node, processedNode);

          case 11:
            _ref3 = _context2.t0;
            contentState = _ref3.contentState;
            currentEntity = _ref3.currentEntity;
            return _context2.abrupt("return", processChildNodes({
              siteId: siteId,
              nodes: node.childNodes,
              currentProcessedNode: _objectSpread(_objectSpread({}, processedNode), {}, {
                contentState: contentState
              }),
              currentEntity: currentEntity
            }));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addLinkEntity(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();